import { render, staticRenderFns } from "./variance-dashboard.vue?vue&type=template&id=2c2384f3&scoped=true&"
import script from "./variance-dashboard.vue?vue&type=script&lang=js&"
export * from "./variance-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./variance-dashboard.vue?vue&type=style&index=0&id=2c2384f3&prod&lang=scss&scoped=true&"
import style1 from "./variance-dashboard.vue?vue&type=style&index=1&id=2c2384f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2384f3",
  null
  
)

export default component.exports